// Функция преобразования числа в слова на русском языке
export function convertNumberToWordsRu(number) {
    const num = parseFloat(number);
    if (isNaN(num) || num === 0) return 'ноль рублей';
    
    const rubles = Math.floor(num);
    const kopecks = Math.round((num - rubles) * 100);
    
    const rublesWords = numberToWords(rubles);
    const kopecksWords = kopecks > 0 ? numberToWords(kopecks) : '';
    
    let result = rublesWords + ' ' + getCurrencyWord(rubles, 'rub');
    if (kopecks > 0) {
        result += ' ' + kopecksWords + ' ' + getCurrencyWord(kopecks, 'kop');
    }
    
    return result;
}

function numberToWords(num) {
    if (num === 0) return 'ноль';
    
    const ones = ['', 'один', 'два', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'];
    const onesFeminine = ['', 'одна', 'две', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'];
    const tens = ['', '', 'двадцать', 'тридцать', 'сорок', 'пятьдесят', 'шестьдесят', 'семьдесят', 'восемьдесят', 'девяносто'];
    const teens = ['десять', 'одиннадцать', 'двенадцать', 'тринадцать', 'четырнадцать', 'пятнадцать', 'шестнадцать', 'семнадцать', 'восемнадцать', 'девятнадцать'];
    const hundreds = ['', 'сто', 'двести', 'триста', 'четыреста', 'пятьсот', 'шестьсот', 'семьсот', 'восемьсот', 'девятьсот'];
    
    const thousands = ['', 'тысяча', 'тысячи', 'тысяч'];
    const millions = ['', 'миллион', 'миллиона', 'миллионов'];
    const billions = ['', 'миллиард', 'миллиарда', 'миллиардов'];
    
    function getOnes(num, isFeminine = false) {
        return isFeminine ? onesFeminine[num] : ones[num];
    }
    
    function getTriadWords(triad, isFeminine = false) {
        let result = '';
        const h = Math.floor(triad / 100);
        const t = Math.floor((triad % 100) / 10);
        const o = triad % 10;
        
        if (h > 0) {
            result += hundreds[h] + ' ';
        }
        
        if (t === 1) {
            result += teens[o] + ' ';
        } else {
            if (t > 1) {
                result += tens[t] + ' ';
            }
            if (o > 0) {
                result += getOnes(o, isFeminine) + ' ';
            }
        }
        
        return result.trim();
    }
    
    function getPluralForm(num, forms) {
        const n = num % 100;
        const n1 = num % 10;
        
        if (n > 10 && n < 20) return forms[2];
        if (n1 > 1 && n1 < 5) return forms[1];
        if (n1 === 1) return forms[0];
        return forms[2];
    }
    
    if (num >= 1000000000) {
        const billionsPart = Math.floor(num / 1000000000);
        const remainder = num % 1000000000;
        return getTriadWords(billionsPart) + ' ' + getPluralForm(billionsPart, billions) + 
               (remainder > 0 ? ' ' + numberToWords(remainder) : '');
    } else if (num >= 1000000) {
        const millionsPart = Math.floor(num / 1000000);
        const remainder = num % 1000000;
        return getTriadWords(millionsPart) + ' ' + getPluralForm(millionsPart, millions) + 
               (remainder > 0 ? ' ' + numberToWords(remainder) : '');
    } else if (num >= 1000) {
        const thousandsPart = Math.floor(num / 1000);
        const remainder = num % 1000;
        const thousandsWord = getPluralForm(thousandsPart, thousands);
        // Для тысяч используется женский род
        const thousandsWords = getTriadWords(thousandsPart, true);
        return thousandsWords + ' ' + thousandsWord + 
               (remainder > 0 ? ' ' + getTriadWords(remainder) : '');
    } else {
        return getTriadWords(num);
    }
}

function getCurrencyWord(num, type) {
    const n = num % 100;
    const n1 = num % 10;
    
    if (type === 'rub') {
        if (n > 10 && n < 20) return 'рублей';
        if (n1 > 1 && n1 < 5) return 'рубля';
        if (n1 === 1) return 'рубль';
        return 'рублей';
    } else if (type === 'kop') {
        if (n > 10 && n < 20) return 'копеек';
        if (n1 > 1 && n1 < 5) return 'копейки';
        if (n1 === 1) return 'копейка';
        return 'копеек';
    }
    return '';
}

